import { defaultMeta } from '@/constants/defaultMeta';
import { parseDateRangeSearch } from '@/lib/parseDateRange';
import { sortBy } from '@/lib/sortBy';
import { useQuery } from '@/react-query/hooks/useQuery/useQuery';
import { commissionQueries } from '@/services/commissions/commissions.queries';
import { useSearch } from '@tanstack/react-router';

export const useCommissionsList = () => {
  const search = useSearch({ from: '/(app)/configuration-management/commissions/' });
  const { sort, page, fetch, createdDate } = search;

  const parsedCreatedDate = parseDateRangeSearch(createdDate, { start: 0, end: 0 });
  const { data, isLoading } = useQuery({
    ...commissionQueries.list({
      row: page ?? 1,
      fetch: fetch ?? 10,
      fromDate: parsedCreatedDate?.start ?? 0,
      toDate: parsedCreatedDate?.end ?? 0,
      search: search.q ?? '',
    }),
    select: (res) => ({
      ...res,
      data: sortBy(res.data, sort),
    }),
  });

  return { commissionsList: data?.data || [], isLoading, meta: data?.meta?.pagination ?? defaultMeta };
};
